import React, { useState, useEffect } from "react";
import "./root.scss";
// import { Button } from "antd";
import { Layout } from "antd";
import { Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom"; //page
// import Box from "@mui/material/Box";
// import HeaderComponent from "../components/header";
// import FooterComponent from "../components/footer";

// Work
import WorkListing from "../pages/works/index"
import WorkView from "../pages/works/worksView/index";
import ApprovalHistory from "../pages/works/approvalHistory/index";


import BatchRiderManagement from "../pages/batch/batchRiderManagement";
import BulkBatchRider from "../pages/batch/batchRiderManagement/bulkCreate";
import BatchDefaultConfiguration from "../pages/batch/batchDefaultConfiguration";
import WalletStacking from "../pages/batch/walletStacking";

import Rider from "../pages/rider";
import RiderAdd from "../pages/rider/addRider";
import RiderDetail from "../pages/rider/detail";
import AWSFileUpload from "../pages/rider/awsFileUpload";

import PerformanceListing from "../pages/performance/list";
import RiderLiveLocation from "../pages/riderLiveLocation/riderLiveLocation";
import RiderSuspendBulkCSV from "../pages/rider/riderSuspendCsvBulk/riderSuspendCsvBulk";
import RiderInactiveBulkCsv from "../pages/rider/riderInactiveCsvBulk/riderInactiveCsvBulk";
import RiderBlockBulkCSV from "../pages/rider/riderBlockCsvBulk/riderBlockCsvBulk";

import Zones from "../pages/zones";
import ZoneAdd from "../pages/zones/zoneAdd";

import Shift from "../pages/shift";
import ShiftView from "../pages/shift/shiftView";
import ShiftAdd from "../pages/shift/shiftAdd";
import ShiftEdit from "../pages/shift/shiftEdit";
import Shiftbulk from "../pages/shift/bulkCreate";
import RiderShiftBulkAssignment from "../pages/shift/riderShiftBulkAssignemt";

import Store from "../pages/store";
import StoreAdd from "../pages/store/storeAdd";
import StoreEdit from "../pages/store/storeEdit";

// import OverviewList from "../pages/overview/overviewList";
import OverviewView from "../pages/overview/overviewView";
import OverviewListPage from "../pages/overview/overviewPage/overviewListPage";

import DashBoard from "../pages/dashboard/dashboard";
import DashBoardNew from "../pages/dashboard/dashboardNew";
import MetricsDashboard from "../pages/dashboard/metricsDashboard/metricsDashboard";
import ShiftsLevel from "../pages/dashboard/levelView/shifts";
import MartLevel from "../pages/dashboard/levelView/mart";

import RiderCurrentOrder from "../pages/dashboard/riderCurrentOrder/riderCurrentOrder";
import RiderCurrentOrderV2 from "../pages/dashboard/riderCurrentOrder/riderCurrentOrderV2";

import BreakList from "../pages/break/breakList";

import DispatcherNotesList from "../pages/dispatcherNotes/list";
import DispatcherNoteAdd from "../pages/dispatcherNotes/add";

import CancellationsReasonsList from "../pages/cancellationsReasons/list";
import CancellationsReasonsAdd from "../pages/cancellationsReasons/add";

import NotificationListing from "../pages/notification/notification/List"
import NotificationAdd from "../pages/notification/notification/add"
import NotificationView from "../pages/notification/notification/view"

import CategoriesListing from "../pages/notification/categories/List"
import CategoriesAdd from "../pages/notification/categories/add"

import CancelledOrder from "../pages/cancelledOrder/cancelledOrder";

import WalletIssues from "../pages/walletIssue";
import WalletComplianceHistory from "../pages/walletComplianceHistory";
import RadiusComplianceHistory from "../pages/radiusComplianceHistory";
import Navbar from "../components/navbar";

import OpenIssue from "../pages/issues/openIssue/openIssue";
import PickedIssue from "../pages/issues/pickedIssue/pickedIssue";
import MyIssue from "../pages/issues/myIssue/myIssue";
import HistoryIssue from "../pages/issues/pickedHistory/pickedHistory";

import Login from "../pages/login";
import MartLogin from "../pages/martLogin";
// import klogo from "../assets/images/fav-ico.png";
// import logo from "../assets/images/kravemart-logo-black.png";

import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import SiteConfig from "../pages/SiteConfig";
import { bindActionCreators } from "redux";
import * as zoneActions from "../redux/actions/zone.actions";
import * as permissionActions from "../redux/actions/permission.actions";
import * as AuthActions from "../redux/actions/auth.actions";

import { DevSDummyPermissionForSiteConfigHelper, DummyPermissionCancellationsreasonsHelper, DummyPermissionHelper, DummyPermissionHelperTriggers, DummyPermissionHelperUnRegisterRider, userhasPermissionHelper, DummyPermissionHelperWork, SiteConfigDevPermissionHelper } from "../utils/Helpers";
import { PERMISSION_CONSTANT } from "../utils/constants/app";
import Page403 from "../pages/Page403";
import Page404 from "../pages/Page404";
import DownloadRockyApp from "../pages/DownloadRockyApp";

// pickerpacker
import PickerPackerListing from "../pages/pickerpacker/listing";
import PickerPackerCreate from "../pages/pickerpacker/create";
import PickerPackerDetail from "../pages/pickerpacker/detail";
import MartHealthDashboard from "../pages/dashboard/martHealthDashboard";

// Triggers
import TriggersListing from "../pages/triggers/listing";
import UnRegisterRider from "../pages/unRegisterRider";
import UnRegisterRidersView from "../pages/unRegisterRider/view";
import DashboardLayout from "../components/dashboardLayout";
import SiteConfigNew from "../pages/SiteConfigNew";
import SiteConfigDev from "../pages/SiteConfigDev";
import ItemLevelInventory from "../pages/ItemLevelInventory";
import CmsPage from "../pages/cms";

// const { Sider, Content } = Layout;

// function DashboardLayout() {
//   const [collapsed, setCollapsed] = useState(false);

//   const toggleCollapsed = () => {
//     setCollapsed(!collapsed);
//   };
//   return (
//     <div>
//       <Layout>
//         <Sider
//           className="rocky-sidebar"
//           trigger={null}
//           collapsible
//           collapsed={collapsed}
//         >
//           <Button className="btn-collapsed" onClick={toggleCollapsed}>
//             {collapsed ? (
//               <img src={klogo} alt="logo" width="75%" />
//             ) : (
//               <img src={logo} alt="logo" width="60%" />
//             )}
//           </Button>
//           <Navbar />
//           <FooterComponent />
//         </Sider>
//         <Layout className="rockey-page-content">
//           <HeaderComponent />
//           <Content className="page content">
//             <Outlet />
//           </Content>
//         </Layout>
//       </Layout>
//     </div>
//   );
// }

const Router = (props) => {
  const navigate = useNavigate();
  const location = useLocation()
  const [loginAuthCheck, setloginAuthCheck] = useState("");
  useEffect(() => {
    if (props.token) {
      setloginAuthCheck(props.token);
      props.permissionActions.getPermissionListAction();
    } else {
      setloginAuthCheck("");
      // console.log("location.pathname: ",location.pathname)
      if(location.pathname != "/download" && location.pathname != "/mart-login") 
      navigate("/");
    }
  }, [props.token]);
  useEffect(() => {
    if(location){
      if(location.pathname == "/dashboard"){
        props.zoneActions.setDashboardDataAction([]);
      }
      if(location.pathname != "/dashboard/mart-health" && props.navbar_collapsed == true){
        props.AuthActions.navbarCollapsedAction(false);
      }
    }
  }, [location]);

  useEffect(() => {
    // console.log(location);
    // console.log("loginAuthCheck: ",loginAuthCheck);
    // console.log(props.token);
    // console.log(props.permissions.length);
    if(location && props.token && (props.permissions?.length == 0) ){
      navigate("403");
    }
    if(location && loginAuthCheck && props.token && props.permissions?.length > 0){
      // console.log(location);
      // console.log(props.token);
      // console.log(props.permissions);
      // console.log(props.permissions.length);
      // permissions Start
      if((userhasPermissionHelper(props.permissions, "permission_not_loded")) === false) {
        // dashboard
        if(location.pathname === "/dashboard" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RS_DASHBOARD) === false)
        ) navigate("403");
        if(location.pathname === "/dashboard/riderorder" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_CURRENT_ORDERS) === false)
        ) navigate("403");
        // batch tab
        if(location.pathname === "/batch" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_BATCH_RIDERS) === false)
        ) navigate("403");
        if(location.pathname === "/batch/defaultconfiguration" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_DEFAULT_CONFIG) === false)
        ) navigate("403");
        if(location.pathname === "/batch/walletstacking" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WALLET_STACKING) === false)
        ) navigate("403");
        // overview
        if(location.pathname.startsWith("/overview") && location.pathname.includes("/overview") &&
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDERS) === false)
        ) navigate("403");
        // zones
        if(location.pathname === "/zones" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ZONES) === false)
        ) navigate("403");
        if(location.pathname === "/zone/add" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_ZONES) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/zoneEdit") && location.pathname.includes("/zoneEdit") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_ZONES) === false)
        ) navigate("403");
        // riders
        if(location.pathname.startsWith("/rider") && location.pathname.includes("/rider") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDERS) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/rider/suspendriderbulk") && location.pathname.includes("/rider/suspendriderbulk") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPENSION_CSV_BULK) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/rider/inactiveriderbulk") && location.pathname.includes("/rider/inactiveriderbulk") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPENSION_CSV_BULK) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/rider/blockriderbulk") && location.pathname.includes("/rider/blockriderbulk") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_SUSPENSION_CSV_BULK) === false)
        ) navigate("403");
        // shifts
        if(location.pathname.startsWith("/shifts") && location.pathname.includes("/shifts") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFTS) === false)
        ) navigate("403");
        // shifts/shiftbulk
        if(location.pathname === "/shifts/shiftbulk" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_UPLOAD_CSV) === false)
        ) navigate("403");
        // shifts/riderShiftbulkAssignment
        if(location.pathname === "/shifts/riderShiftbulkAssignment" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_UPLOAD_CSV) === false)
        ) navigate("403");
        // break
        if(location.pathname.startsWith("/break") && location.pathname.includes("/break") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_BREAK) === false)
        ) navigate("403");
        // dispatchernote
        if(location.pathname.startsWith("/dispatchernote") && location.pathname.includes("/dispatchernote") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_ORDER_DISPATCHER_NOTES) === false)
        ) navigate("403");
        // notifications
        if(location.pathname.startsWith("/notification") && location.pathname.includes("/notification") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_NOTIFICATION) === false)
        ) navigate("403");
        // categories
        if(location.pathname.startsWith("/categories") && location.pathname.includes("/categories") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_NOTIFICATION) === false)
        ) navigate("403");
        // riderlocation permission for dummy users
        // if(location.pathname.startsWith("/riderlocation") && location.pathname.includes("/riderlocation") && 
        //   (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_LIVE_LOCATION_MAP) === false)
        // ) navigate("403");
        if(location.pathname.startsWith("/riderlocation") && location.pathname.includes("/riderlocation") && 
          !(DummyPermissionHelper(props?.user?.email)) 
        ) navigate("403");
        // rider suspended csv
        if(location.pathname.startsWith("/rider/suspendriderbulk") && location.pathname.includes("/rider/suspendriderbulk") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_RIDERS) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/site/config") && !location.pathname.startsWith("/site/config-dev") && location.pathname.includes("/site/config") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SITE_CONFIG_DASHBOARD) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/site/config-new") && location.pathname.includes("/site/config-new") &&
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SITE_CONFIG_DASHBOARD) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/site/config-dev") && location.pathname.includes("/site/config-dev") &&
          !(SiteConfigDevPermissionHelper(props?.user?.email))
        ) navigate("403");
        if(location.pathname === "/riderlocation" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_LOCATION) === false)
        ) navigate("403");
        if(location.pathname === "/cancelledorder" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_CANCELLED_ORDERS_DASHBOARD) === false)
        ) navigate("403");
        // issues
        if(location.pathname === "/openissues" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_OPEN_ISSUES) === false)
        ) navigate("403");
        if(location.pathname === "/pickedissues" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICKED_OPEN_ISSUES) === false)
        ) navigate("403");
        if(location.pathname === "/myissues" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_MY_OPEN_ISSUES) === false)
        ) navigate("403");
        if(location.pathname === "/historyissues" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ISSUES_HISTORY) === false)
        ) navigate("403");
        // performance dashboard
        if(location.pathname === "/performance" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PERFORMANCE_KPI_DASHBOARD) === false)
        ) navigate("403");
        // pickerpacker
        if(location.pathname.startsWith("/pickerpacker") && location.pathname.includes("pickerpacker") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICKER_PACKER) === false)
        ) navigate("403");
        if(location.pathname === "/pickerpacker/add" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICKER_PACKER) === false)
        ) navigate("403");
        if(location.pathname.startsWith("/cancellationsreasons") && location.pathname.includes("/cancellationsreasons") && 
          !(DummyPermissionCancellationsreasonsHelper(props?.user?.email)) 
        ) navigate("403");
        if(location.pathname === "/triggers" && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_TRIGGERS) === false)
        ) navigate("403");

        if(location.pathname.startsWith("/works") && 
          (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WORK) === false)
        ) navigate("403");

        if(location.pathname.startsWith("/un-register/rider") && location.pathname.includes("/un-register/rider") && 
          !(DummyPermissionHelperUnRegisterRider(props?.user?.email)) 
        ) navigate("403");
      }
      // permissions End
    }
  }, [location, props.token, props.permissions]);
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  return (
    <Routes>
      <Route path="/download" element={<DownloadRockyApp />} />
      { 
        loginAuthCheck != "" ? 
          <Route path="/" element={<DashboardLayout  />}>
            <Route path="/" element={<OverviewListPage />} showAlert={showAlert} />
            {/* Rider Start */}
            <Route exact="true" path="/rider" element={<Rider />} />
            <Route exact="true" path="/rider/add" element={<RiderAdd />} />
            <Route path="/rider/:riderid" element={<RiderDetail />} />
            <Route path="/rider/awsFileUpload" element={<AWSFileUpload />} />
            <Route eaxct path="rider/suspendriderbulk" element={<RiderSuspendBulkCSV />} />
            <Route eaxct path="rider/inactiveriderbulk" element={<RiderInactiveBulkCsv />} />
            <Route eaxct path="rider/blockriderbulk" element={<RiderBlockBulkCSV />} />
            {/* Rider End */}

            {/* Un-register Rider Start */}
            <Route exact="true" path="/un-register/rider" element={<UnRegisterRider />} />
            <Route exact="true" path="/un-register/rider/:riderId" element={<UnRegisterRidersView />} />
            {/* Un-register Rider End */}

            {/* Performance Start */}
            <Route exact="true" path="/performance" element={<PerformanceListing />} />

            {/* Performance End */}
            {/* Rider Location Start */}
            <Route path="/riderlocation" element={<RiderLiveLocation />} />
            {/* Rider Location End */}


            {/* Batch Start */}
            <Route
              exact="true"
              path="/batch"
              element={<BatchRiderManagement />}
            />
            <Route
              path="/batch/defaultconfiguration"
              element={<BatchDefaultConfiguration />}
            />
            <Route
              path="/batch/bulkbatchrider"
              element={<BulkBatchRider />}
            />
            <Route
              path="/batch/walletstacking"
              element={<WalletStacking />}
            />
            {/* Batch End */}

            {/* Zone Start */}
            <Route eaxct path="/zones" element={<Zones />} />
            <Route eaxct path="/zone/add" element={<ZoneAdd />} />
            <Route eaxct path="/zoneEdit/:zoneId" element={<ZoneAdd />} />
            {/* Zone End */}

            {/* Shift Start */}
            <Route eaxct path="/shifts" element={<Shift />} />
            <Route
              eaxct
              path="/shifts/shiftView/:shiftId"
              element={<ShiftView />}
            />
            <Route eaxct path="/shifts/shiftcreate" element={<ShiftAdd />} />
            <Route
              eaxct
              path="/shifts/shiftEdit/:shiftId"
              element={<ShiftEdit />}
            />
            <Route eaxct path="shifts/shiftbulk" element={<Shiftbulk />} />
            <Route
              eaxct
              path="shifts/riderShiftbulkAssignment"
              element={<RiderShiftBulkAssignment />}
            />
            {/* Shift End */}

            {/* Stores Start */}
            <Route eaxct path="/stores" element={<Store />} />
            <Route eaxct path="/stores/storecreate" element={<StoreAdd />} />
            <Route
              path="/Stores/Storesedit/:Storeid"
              element={<StoreEdit />}
            />
            {/* Stores End */}

            {/* OverView Start */}
            {/* <Route path="/overview" element={userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDERS) ?  <OverviewList /> : <Page403 />} /> */}
            <Route path="/overview" element={<OverviewListPage />} />
            <Route path="/overview/:overviewdashboardid" element={<OverviewView />} />
            {/* <Route path="/overviewold" element={<OverviewList />} /> */}
            {/* OverView End */}

            {/* Wallet Issue Start */}
            <Route path="/wallet/issues" element={<WalletIssues />} />
            <Route path="/wallet/compliance-history" element={<WalletComplianceHistory />} />
            <Route path="/radius/compliance-history" element={<RadiusComplianceHistory />} />
            {/* Wallet Issue End */}

            {/* DashBoard Start */}
            <Route path="/dashboard-old" element={<DashBoard />} />
            <Route path="/dashboard" element={<DashBoardNew />} />
            <Route path="/dashboard/riderorder-old" element={<RiderCurrentOrder />} />
            <Route path="/dashboard/riderorder" element={<RiderCurrentOrderV2 />} />
            <Route path="/dashboard/metricsdashboard" element={<MetricsDashboard />} />
            <Route path="/dashboard/shifts" element={<ShiftsLevel />} />
            <Route path="/dashboard/mart" element={<MartLevel />} />
            <Route path="/dashboard/mart-health" element={<MartHealthDashboard />} />
            {/* DashBoard End */}

            {/* Break Start */}
            <Route path="/break" element={<BreakList />} />
            {/* Break End */}

            {/* Dispatcher Notes Start */}
            <Route path="/dispatchernote" element={<DispatcherNotesList />} />
            <Route path="/dispatchernote/add" element={<DispatcherNoteAdd />} />
            <Route path="/dispatchernote/add/:postid" element={<DispatcherNoteAdd />} />
            {/* Dispatcher Notes End */}

            {/* Dispatcher Notes Start */}
            <Route path="/cancellationsreasons" element={<CancellationsReasonsList />} />
            <Route path="/cancellationsreasons/add" element={<CancellationsReasonsAdd />} />
            <Route path="/cancellationsreasons/edit/:postid" element={<CancellationsReasonsAdd />} />
            {/* Dispatcher Notes End */}

            {/* Notification Notes Start */}
            <Route path="/notification" element={<NotificationListing />} />
            <Route path="/notification/add" element={<NotificationAdd />} />
            <Route path="/notification/:postid" element={<NotificationView />} />
            <Route path="/categories" element={<CategoriesListing />} />
            <Route path="/categories/add" element={<CategoriesAdd />} />
            <Route path="/categories/add/:postid" element={<CategoriesAdd />} />
            {/* Notification Notes End */}

            {/* Issues Start */}
            <Route path="/openissues" element={<OpenIssue />} />
            <Route path="/pickedissues" element={<PickedIssue />} />
            <Route path="/myissues" element={<MyIssue />} />
            <Route path="/historyissues" element={<HistoryIssue />} />
            
            {/* Issues End */}
            {/* Cancelled Order Start */}
            <Route path="/cancelledorder" element={<CancelledOrder />} />
            {/* Cancelled Order End */}

            {/* Picker Packer Start */}
            <Route exact="true" path="/pickerpacker" element={<PickerPackerListing />} />
            <Route exact="true" path="/pickerpacker/add" element={<PickerPackerCreate />} />
            <Route path="/pickerpacker/:postid" element={<PickerPackerDetail />} />
            {/* Picker Packer End */}

            {/* Picker Packer Start */}
            <Route exact="true" path="/triggers" element={<TriggersListing />} />
            {/* Picker Packer End */}

            {/* Packmate Work Start */}
            <Route exact="true" path="/works" element={<WorkListing />} />
            <Route exact="true" path="/works/approval-history" element={<ApprovalHistory />} />
            <Route exact="true" path="/works/:workId" element={<WorkView />} />
            {/* Packmate Work End */}
            <Route exact="true" path="/item-level-inventory" element={<ItemLevelInventory />} />

            {/* CMS */}
            <Route exact="true" path="/cms" element={<CmsPage />} />

            <Route path="/site/config" element={<SiteConfig />} />
            <Route path="/site/config-new" element={<SiteConfigNew />} />
            <Route path="/site/config-dev" element={<SiteConfigDev />} />
            <Route path="/403" element={<Page403 />} />
            <Route path="*" element={<Page404 />} />
          </Route>
        :
          <>
            <Route index path="/" element={<Login />} showAlert={showAlert} />
            <Route path="/login" element={<Login />} />
            <Route path="/mart-login" element={<MartLogin />} />
            <Route path="/403" element={<Login />} />
            {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
          </>      
      }
    </Routes>
  )
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    token: state.authReducer.token,
    navbar_collapsed: state.authReducer.navbar_collapsed,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    permissionActions: bindActionCreators(permissionActions, dispatch),
    AuthActions: bindActionCreators(AuthActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Router);
